module.exports = __webpack_public_path__ + "img/02.659ae6d3.png";